// Zentrale Routen-Map: pro Seite gibt es einen DE- und einen EN-Slug.
// Beide Pfade werden in router/config.tsx auf dieselbe Komponente registriert,
// damit die Live-Site mit BrowserRouter saubere URLs ausliefern kann
// (z. B. /zimmer für DE, /rooms für EN) und Google sie korrekt indexiert.

export type RouteKey =
  | 'home'
  | 'rooms'
  | 'hotel'
  | 'ausflugsziele'
  | 'buchen'
  | 'impressum'
  | 'datenschutz'
  | 'agb';

export const PATHS: Record<RouteKey, { de: string; en: string }> = {
  home:          { de: '/',              en: '/en' },
  rooms:         { de: '/zimmer',        en: '/rooms' },
  hotel:         { de: '/hotel',         en: '/the-hotel' },
  ausflugsziele: { de: '/ausflugsziele', en: '/things-to-do' },
  buchen:        { de: '/buchen',        en: '/book' },
  impressum:     { de: '/impressum',     en: '/imprint' },
  datenschutz:   { de: '/datenschutz',   en: '/privacy' },
  agb:           { de: '/agb',           en: '/terms' },
};

export type Lang = 'de' | 'en';

export function pathFor(key: RouteKey, lang: Lang): string {
  return PATHS[key][lang];
}

// Liefert den Routen-Key für einen aktuellen Pfad (egal ob DE oder EN).
export function routeKeyFromPath(pathname: string): RouteKey | null {
  for (const key of Object.keys(PATHS) as RouteKey[]) {
    if (PATHS[key].de === pathname || PATHS[key].en === pathname) return key;
  }
  return null;
}

// Liefert das Sprach-Pendant zur aktuellen Route (z. B. /zimmer ↔ /rooms).
export function alternatePath(pathname: string, targetLang: Lang): string {
  const key = routeKeyFromPath(pathname);
  if (!key) return pathname;
  return PATHS[key][targetLang];
}
